module.exports = __webpack_public_path__ + "static/media/Apple iPad Air Space Grey.92462089.png";